import { DropdownMenu } from "@bigbinary/neeto-atoms";

import Submenu from "./Submenu";

const MenuItem = ({
  onClick,
  label,
  type = "menuItem",
  hasSubItems = false,
  menuItems,
  dropdownProps,
  ...menuItemProps
}) => {
  if (type === "divider") return <DropdownMenu.Divider role="separator" />;

  if (hasSubItems) {
    return (
      <Submenu {...{ dropdownProps, label, menuItems, ...menuItemProps }} />
    );
  }

  return (
    <DropdownMenu.MenuItem.Button
      {...{ onClick }}
      role="menuitem"
      {...menuItemProps}
    >
      {label}
    </DropdownMenu.MenuItem.Button>
  );
};

export default MenuItem;
